<ng-template [ngIf]="!isLogged">
    <router-outlet></router-outlet>
</ng-template>

<ng-template [ngIf]="isLogged">
    <app-layout />
</ng-template>

<p-toast />
